import dlv from "dlv";

export default function getResource(store, model, id) {
  return dlv(store, `api.${model}.${isNaN(id) ? id : `/${model}/${id}`}`, null);
}
